import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
const StyledPanel = styled.div `
    padding: ${props => props.hasNarrowPanelHeight ? '15px 15px 5px 15px' : '25px'};
    border-radius: 6px;
    background-color: white;
    box-shadow: 0 0 5px rgba(26, 26, 26, 0.1);
    margin: ${props => (props.margin ? props.margin : '0 0 15px 0')};

    @media only screen and (min-width: 768px) {
        padding: ${props => props.hasNarrowPanelHeight ? '15px 25px 10px 25px' : '25px'};
    }
`;
const Panel = ({ className, children, margin, hasNarrowPanelHeight, }) => (_jsx(StyledPanel, { className: className, margin: margin, hasNarrowPanelHeight: hasNarrowPanelHeight, children: children }));
export default Panel;
